var _a;
import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { map, switchMapTo } from "rxjs/operators";
import { TypeActionApp } from "../app/actionApp";
import { actionPlayerSettingsBlogVersionReceived } from "../info/player-settings/actionPlayerSettingsInfo";
var url = process.env.REACT_APP_BLOG_URL + "/version";
var headers = (_a = {},
    _a["Content-Type"] = "text/plain;charset=UTF-8",
    _a);
export var epicBlogGetVersion = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(ajax({
        async: true,
        crossDomain: true,
        headers: headers,
        method: "GET",
        responseType: "text",
        url: url,
    })), map(function (response) {
        return actionPlayerSettingsBlogVersionReceived(parseInt(response.response, 10));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/settings/epicBlogGetVersion.ts
// module id = 2332
// module chunks = 3